import { createFileRoute, redirect } from '@tanstack/react-router';

// Drilldown stub for `/admin/finance/expenditures/{expenditureId}`. No
// per-expenditure detail page exists today; the Close ledger (`staged` pivot
// at the match view) is the surface where treasurers fix or confirm an
// individual expenditure. The id is preserved as a search param — mirroring
// the contribution drilldown — so a future per-row focus can read it without
// breaking bookmarks.
//
// Synthesized fee Expenditures (ADR-005 deterministic-GUID rows) are rendered
// text-only at the report and never link here.
export const Route = createFileRoute('/admin/finance/expenditures/$expenditureId')({
  beforeLoad: ({ params }: { params: { expenditureId: string } }) => {
    throw redirect({
      to: '/admin/finance/transactions',
      search: {
        status: 'staged' as const,
        view: 'match' as const,
        expenditureId: params.expenditureId,
      },
    });
  },
});
